import Link from "next/link";

interface FooterCategory {
	title: string;
	category: { name: string; href: string }[];
	className?: string;
}

const FooterCategory = ({ title, category, className }: FooterCategory) => {
	return (
		<article className={className}>
			<h3 className="mb-1 font-medium text-gray-900 text-lg dark:text-gray-50">
				{title}
			</h3>
			<ul className="flex flex-col gap-2">
				{category.map((item) => (
					<li key={item.name}>
						<Link
							prefetch={false}
							href={item.href}
							className="text-base text-gray-500 hover:text-gray-900 dark:text-gray-300 hover:dark:text-gray-400"
						>
							{item.name}
						</Link>
					</li>
				))}
			</ul>
		</article>
	);
};

export default FooterCategory;
